/**
 * 是否数组
 */
export function isArray(value) {
  if (typeof Array.isArray === "function") {
    return Array.isArray(value);
  } else {
    return Object.prototype.toString.call(value) === "[object Array]";
  }
}
/**
 * 是否对象
 */
export function isObject(value) {
  return Object.prototype.toString.call(value) === "[object Object]";
}

/**
 * 判断为空
 * @param val
 * @returns {boolean}
 */
export const isEmpty = function(val) {
  // null or undefined
  if (val === null) return true;

  if (typeof val === 'boolean') return false;

  if (typeof val === 'number') return isNaN(val);

  if (val instanceof Error) return val.message === '';

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case '[object String]':
    case '[object Array]':
      return !val.length;

    // Map or Set or File
    case '[object File]':
    case '[object Map]':
    case '[object Set]': {
      return !val.size;
    }
    // Plain Object
    case '[object Object]': {
      return !Object.keys(val).length;
    }
  }

  return false;
};
/**
 * 清空对象中值为空的key
 * @param data
 * @returns {*}
 */
export function clearNullValueWithinObject (data) {
  let keys = Object.keys(data).filter(res=>empty(data[res]));
  keys.forEach(key=>{
    delete data[key]
  });
  function empty(res){
    if(res === 0) return false;
    return isEmpty(res)
  }
  return data
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/my-tools-kit/src/modules/type.js
// module id = null
// module chunks = 